export default class Timer {

    time: number = 0;
    get isEnd(): boolean {
        return this.time <= 0
    }
    private timer: any = null;

    constructor(time: number) {
        this.time = time;
        this.timer = setInterval(() => {
            if (this.time <= 0) {
                clearInterval(this.timer);
                this.time = null;
            } else this.time -= 1000;
        }, 1000);
    }

    dispose(){
        clearInterval(this.timer);
    }
}